<template>
  <v-app
    class=main--text>
    <v-content>
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            sm=6>
            <v-card>
              <v-container
                fluid>
                <v-row
                  justify=center>
                <v-card-title>
                  LINE公式アカウントへ
                </v-card-title>
                <v-card-title>
                  ジャンプします。
                </v-card-title>
              </v-row>
              <v-row>
                <v-col></v-col>
              </v-row>
              <v-row
                justify=center>
                <v-card-subtitle>
                  ジャンプしない場合は、<a href="https://lin.ee/oKN5sWr">こちら</a>
                </v-card-subtitle>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  metaInfo: {
    meta: [
      {
        'http-equiv': "refresh",
        content: "1;URL=https://lin.ee/oKN5sWr",
      }
    ]
  },
  head: {
    script: [
      {i: "gtag('event', 'conversion', {'send_to': 'AW-722264234/ccSWCK_2rbkBEKrBs9gC'})"}
    ]
  }
}
</script>
